export default __webpack_public_path__ + "static/pic05-baf34b468012d740baade913fd742d81.jpg";